export default {
  apiVersion: 2,
  development: {
    accessToken: '8ef079701aab317f991beae4cee8bf6a',
    url: 'http://americanstyle.dev.moya.is/_/moya/pilot/api',
  },
  staging: {
    accessToken: '8ef079701aab317f991beae4cee8bf6a',
    url: 'https://www.americanstyle.is/_/moya/pilot/api',
  },
  production: {
    accessToken: '8ef079701aab317f991beae4cee8bf6a',
    url: 'https://www.americanstyle.is/_/moya/pilot/api',
  },
};
